import React, { FC } from "react";
import { useHistory, useParams } from "react-router-dom";
import StickyHeader from "modules/Common/Components/StickyHeader";
import StickyHeaderContent from "modules/Common/Components/StickyHeaderContent";
import StickyHeaderContentWithBackButton from "modules/Common/Components/StickyHeaderContentWithBackButton";
import TabsWrapper from "modules/Common/Components/TabsWrapper";
import AudienceTabOption from "./AudienceTabOption";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { getQueryParam } from "utils";
import { editContactListName } from "../Lists/actions";
import useQuery from "./../../../../hooks/useQuery";
export type AudienceParams = {
  page?: string;
};

const AudienceHeaderSticky: FC = (props) => {
  const { page } = useParams<AudienceParams>();
  let query = useQuery();
  let fromQuery = query.get("from") || "/audiences/lists";
  let workflowId = query.get("workflow_id");
  if (fromQuery !== "/audiences/lists") {
    const emailId = query.get("email_id");
    fromQuery += "&email_id=" + emailId;
  } else if (workflowId) {
    fromQuery = "/automation/details?workflow_id=" + workflowId;
  }

  const listName = useSelector((state: RootState) => state.audienceListDetails.listName);

  const tabsArray = [
    // {
    //   pillName: "Dashboard",
    //   to: "javascript: void(0);",
    //   isActive: page === undefined || page === "/",
    //   onClick: (e: any) => e.preventDefault(),
    // },
    // {
    //   pillName: "Accounts",
    //   to: `/`,
    //   isActive: page === TAB_ANALYTICS.ACCOUNTS,
    // },
    {
      pillName: "Lists",
      isActive: page === "lists",
      to: `/audiences/lists`,
    },
    {
      pillName: "Contacts",
      isActive: page === "people",
      to: `/audiences/people`,
    },
  ];
  //handler for saving new list name
  function saveNewListName(newName: string) {
    if (listName !== newName) {
      const listId = getQueryParam("list_id");
      editContactListName(listId, newName);
    }
  }

  return (
    <>
      <Wrapper>
        <StickyHeader>
          {window.location.pathname.endsWith("/view") ? (
            <StickyHeaderContentWithBackButton
              goBackURL={fromQuery}
              itemName={listName}
              saveNewListName={saveNewListName}
              commasNotAllowed={true} // commas are not allowed in list names
            >
              <TabsWrapper>{<AudienceTabOption tabArray={tabsArray} />}</TabsWrapper>
            </StickyHeaderContentWithBackButton>
          ) : (
            <StickyHeaderContent
              showBack={getQueryParam("email_id").length > 0 || getQueryParam("uuid").length > 0}
              label={"Audiences"}
            >
              <TabsWrapper>{<AudienceTabOption tabArray={tabsArray} />}</TabsWrapper>
            </StickyHeaderContent>
          )}
        </StickyHeader>
      </Wrapper>
    </>
  );
};

export default AudienceHeaderSticky;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 75px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding-top: 66px;
  }
`;
